import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, inject } from "@angular/core"
import { IconImageService } from "@shared/services/icon-image.service"

let nextId = 0

@Component({
  selector: "flow-search-input",
  templateUrl: "./flow-search-input.component.html",
  styleUrl: "./flow-search-input.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class FlowSearchInputComponent {
  iconService = inject(IconImageService)

  @Input() label: string = ""
  @Input() value: string = ""
  @Input() placeholder: string = "Search here"
  @Input() disabled: boolean = false
  @Input() loading: boolean = false
  @Input() error: boolean = false
  @Input() minChars: number = 3
  @Input() helperText: string = ""
  @Input() maxLength: number | null = null
  @Input() searchButtonShown: boolean = true

  @Output() valueChange = new EventEmitter<string>()
  @Output() search = new EventEmitter<string>()
  @Output() clear = new EventEmitter<void>()

  public focused: boolean = false

  public readonly fieldId = `flow-search-input-${nextId++}`

  public get characterCount(): number | null {
    return this.maxLength === null ? null : this.value.length
  }

  public get showHelper(): boolean {
    return !!this.helperText || this.maxLength !== null
  }

  public get canSearch(): boolean {
    return this.value.trim().length >= this.minChars
  }

  public get showSearchButton(): boolean {
    return this.searchButtonShown && this.value.length > 0
  }

  public get showClear(): boolean {
    return !this.loading && this.value.length > 0
  }

  public get hasValue(): boolean {
    return this.value.length > 0
  }

  public onInput(value: string): void {
    this.value = value
    this.valueChange.emit(value)
  }

  public onFocus(): void {
    this.focused = true
  }

  public onBlur(): void {
    this.focused = false
  }

  public onSearch(): void {
    if (this.disabled || this.loading || !this.canSearch) return
    this.search.emit(this.value.trim())
  }

  public onClear(): void {
    if (this.disabled) return
    this.value = ""
    this.valueChange.emit("")
    this.clear.emit()
  }
}
